import { render, staticRenderFns } from "./push_article.vue?vue&type=template&id=42424a86&scoped=true&"
import script from "./push_article.vue?vue&type=script&lang=js&"
export * from "./push_article.vue?vue&type=script&lang=js&"
import style0 from "./push_article.vue?vue&type=style&index=0&id=42424a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42424a86",
  null
  
)

export default component.exports